import { Component, inject, OnInit } from '@angular/core';
import { FooterAppComponent } from "../../footer-app/footer-app.component";
import { BannerAppComponent } from "../../banner-app/banner-app.component";
import { ActivatedRoute, Router } from '@angular/router';
import { REDIRECT } from '../../../routes.constans';
import { TrackingService } from '../../../services/tracking.service';

@Component({
  selector: 'app-no-preparados',
  standalone: true,
  imports: [FooterAppComponent, BannerAppComponent],
  templateUrl: './no-preparados.component.html',
  styleUrl: './no-preparados.component.scss'
})
export class NoPreparadosComponent implements OnInit {
  private trackingService = inject(TrackingService);
  codAsesor: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe(params => {
      this.codAsesor = params['codigoAsesor'] || '';
    });
  }
  ngOnInit(): void {

    this.trackingService.enviarEventoNoHaySeguro('no_hay_seguro_estado','Pageview');
    
  }

  volverInicio(): void {
    const queryParams = this.codAsesor ? { codigoAsesor: this.codAsesor } : {};
    this.trackingService.enviarEventoNoHaySeguro('no_hay_seguro_estado','Button','Enviar');
    this.router.navigate([REDIRECT], { queryParams });
  }
}
